/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-03-11 13:13:03
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-03-17 16:07:02
 * @FilePath: /dsicm-admin-web/src/utils/req.js
 */
/*
    axios请求接口封装的工具文件

*/
//引入axios 文件
import axios from "axios";
import qs from "qs";
import { Message } from "element-ui";
export default {
    //封装get请求
    get(url, params) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params
            }).then((res) => { 
                if (res.data.success || res.data.code == 500050) {
                    resolve(res.data) //then接收成功参数
                } else {
                    Message({
                        type: 'error',
                        message: res.data.message
                    });
                    reject(res.data)
                }
            }).catch((err) => reject(err));
        });
    },
    getUpload(url, params) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params,
                responseType: 'blob'
            }).then((res) => { 
                if (res && res.data instanceof Blob && res.data.type === "application/json") { 
                    res.data.text().then(text => {    
                      const json = JSON.parse(text);   
                      reject(json)
                    });
                  }else{ 
                     resolve(res.data)
                  } 
            })
            .catch(
                (err) => reject(err) //接收失败参数
            );
        });
    },
    // //封装get请求  勿动
    // getCopy(url, params) {
    //   return new Promise((resolve, reject) => {
    //     axios
    //       .get(url, { params })
    //       .then(
    //         (res) =>
    //           resolve(res) //then接收成功参数
    //       )
    //       .catch((err) => reject(err))
    //   })
    // },
    //封装JSON数据格式post请求
    post(url, params, ...regs) {
        return new Promise((resolve, reject) => {
            axios
                .post(url, JSON.stringify(params), ...regs)
                .then((res) => {
                    if (res.data.success || res.data.code == 320072 || res.data.code == 110093) {
                        if (url.indexOf('/patient-case-history/list') >= 0) {
                            res.data.params = params
                        }
                        resolve(res.data) //then接收成功参数
                    } else {
                        Message({
                            type: 'error',
                            message: res.data.message
                        });
                        reject(res.data)
                    } //接收成功参数
                })
                .catch(
                    (err) => reject(err) //接收失败参数
                );
        });
    },
    // 导出接口
    postUpload(url, params, ...regs) {
        return new Promise((resolve, reject) => {
            axios
                .post(url, JSON.stringify(params), ...regs)
                .then((res) => {
                    console.log(res.data.byteLength, "resdssss");
                    // return;
                    if (res.data.byteLength <= 100) {
                        Message({
                            type: 'error',
                            message: '无数据下载'
                        });
                    } else {
                        resolve(res.data) //then接收成功参数
                    }

                })
                .catch(
                    (err) => reject(err) //接收失败参数
                );
        });
    },

    //封装put请求
    put(url, params, ...regs) {
        return new Promise((resolve, reject) => {
            axios
                .put(url, JSON.stringify(params),...regs)
                .then((res) => {
                    if (res.data.success) {
                        resolve(res.data) //then接收成功参数
                    } else {
                        Message({
                            type: 'error',
                            message: res.data.message
                        });
                        reject(res.data)
                    }
                })
                .catch(
                    (err) => reject(err) //接收失败参数
                );
        });
    },
    //封装delete请求
    delete(url, params) {
        return new Promise((resolve, reject) => {
            axios
                .delete(url, qs.stringify(params))
                .then((res) => {
                    if (res.data.success) {
                        resolve(res.data) //then接收成功参数
                    } else {
                        Message({
                            type: 'error',
                            message: res.data.message
                        });
                        reject(res.data)
                    }
                })
                .catch(
                    (err) => reject(err) //接收失败参数
                );
        });
    },
    del(url, params) {
        return new Promise((resolve, reject) => {
            axios
                .delete(url,{data:{...params}})
                .then((res) => {
                    if (res.data.success) {
                        resolve(res.data) //then接收成功参数
                    } else {
                        Message({
                            type: 'error',
                            message: res.data.message
                        });
                        reject(res.data)
                    }
                })
                .catch(
                    (err) => reject(err) //接收失败参数
                );
        });
    },
};
